import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap } from 'rxjs';

import { environment } from '@environment';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (req.url.startsWith(`${environment.baseUrl}/v1/`)) {
    return auth.getAuthToken().pipe(
      switchMap(session => {
        const headers = req.headers.set('Authorization', `Bearer ${session?.tokens?.accessToken}`);
        req = req.clone({
          headers,
        });
        return next(req).pipe(
          catchError(err => {
            if (err.status === 401) {
              auth.logout();
              router.navigate(['/signin']);
            }
            if (err.status === 402) {
              router.navigate(['/main/subscribe']);
            }
            throw err;
          })
        );
      })
    );
  } else {
    return next(req);
  }
};
